module.exports = __webpack_public_path__ + "img/nestIcon.19ae0c9d.png";